var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { key: _vm.key, staticClass: "d-flex flex-column" }, [
    !_vm.hasConversation
      ? _c(
          "div",
          {
            staticClass:
              "flex-grow-1 d-flex justify-content-center align-items-center",
          },
          [
            _c("h5", { staticClass: "text-muted-light" }, [
              _vm._v("No conversation selected"),
            ]),
          ]
        )
      : _c(
          "div",
          {
            staticClass: "chat-viewer flex-grow-1 d-flex flex-column",
            style: _vm.styles,
          },
          [
            _c("info-panel", {
              staticClass: "flex-shrink-0 flex-grow-0",
              attrs: { conversation: _vm.current },
            }),
            _vm._v(" "),
            _c("chat", {
              ref: "chat",
              staticClass: "flex-shrink-0 flex-grow-1",
              attrs: {
                "adaptive-refresh": true,
                "auto-refresh": true,
                types: _vm.types,
                conversation: _vm.current,
                "index-url": _vm.current.message_index_url,
                styles: _vm.styles,
                "index-media-url": _vm.indexMediaUrl,
                "store-media-url": _vm.storeMediaUrl,
                "can-create-media": _vm.canCreateMedia,
              },
            }),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }